export function setStorageCarrito(carrito) {
    localStorage.removeItem('carrito');
    localStorage.setItem('carrito', JSON.stringify(carrito) )  
}


export function getStorageCarrito() {
    
   const data =  JSON.parse( localStorage.getItem('carrito') )

   if(!data)return [] //Si no hay datos retorna un arreglo vacio
   
    return data
}

export function clearStorageCarrito() {
    
    localStorage.removeItem('carrito');
 }